import getRtpState from '~/client/features/LiveRtp/modules/shared/helpers/getRtpState';
import getRtpStateColor from '~/client/features/LiveRtp/modules/shared/helpers/getRtpStateColor';
import RtpArrow from '~/client/features/LiveRtp/modules/shared/RtpArrow';
import Translate from '~/client/shared/i18n/Translate';
import Container from './styles/Container';

type Props = {
  rtp?: number;
  rtpLive?: number;
  highlight?: boolean;
  translateId: string;
};

const Column: FC<Props> = ({ rtp, rtpLive, highlight, translateId }) => {
  if (!rtpLive || !rtp) {
    return null;
  }
  const state = getRtpState(rtp, rtpLive);
  const color = getRtpStateColor(state);
  return (
    <Container highlight={highlight}>
      <span className="text-moon-12 text-trunks">
        <Translate id={translateId} />
      </span>
      <span className="text-moon-12 font-medium">{rtpLive}%</span>
      <RtpArrow state={state} color={color} />
    </Container>
  );
};

export default Column;
